module.exports = __webpack_public_path__ + "media/לול.722bb1d5.mp3";